import { render, staticRenderFns } from "./ChatReplyPreview.vue?vue&type=template&id=40fcc296&scoped=true"
import script from "./ChatReplyPreview.vue?vue&type=script&lang=js"
export * from "./ChatReplyPreview.vue?vue&type=script&lang=js"
import style0 from "./ChatReplyPreview.vue?vue&type=style&index=0&id=40fcc296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fcc296",
  null
  
)

export default component.exports